import Draggable from "react-draggable";
import Paper, { PaperProps } from "@mui/material/Paper";

const PaperComponent = (props: PaperProps) => {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
};

export default PaperComponent;
